import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router';
import { Button, CardBody, CardFooter, CardHeader, FormCheckbox } from 'view/components/common';
import { Spinner } from 'view/components/layout';
import { useCurrentUser, useUserAddress } from 'view/hooks';
import { EditInfoButton, InfoList, Paragraph, Row } from './UserInfo.styles';

interface InfoProps {
    stepNavigator : (increment: boolean) => () => void;
}

export const UserInfo: React.FC<InfoProps> = ({ stepNavigator }) => {
    const history = useHistory();

    const [ loading, setLoading ] = useState(false);
    const [ hasAgreed, setHasAgreed ] = useState(false);

    const { currentUser } = useCurrentUser();
    const { fullAddress } = useUserAddress();

    const toggleCheckBox = () => {
        setHasAgreed(!hasAgreed);
    };

    const onSubmit = useCallback(() => {
        setLoading(true);
        setTimeout(() => {
            stepNavigator(true)();
        }, 500);
    }, [ stepNavigator ]);

    const goToProfile = () => history.push('/profile');

    return (
        <>
            <CardHeader
                content={'Applicant Information'}
                step={'Step 2'}
                backHandler={stepNavigator(false)}
            />
            {loading ? (
                <Spinner css='height: inherit; margin-top: 175px;' />
            ) : (
                <CardBody>
                    <InfoList>
                        <li><Paragraph>Name: {currentUser?.fullname}</Paragraph></li>
                        <li><Paragraph>Address: {fullAddress}</Paragraph></li>
                    </InfoList>
                    <Row>
                        <div>
                            <FormCheckbox
                                name={'hasAgreed'}
                                checked={hasAgreed}
                                onChange={toggleCheckBox}
                            />
                        </div>
                        <div>
                            <Paragraph>
                                I confirm the above information is correct.
                            </Paragraph>
                        </div>
                    </Row>
                </CardBody>
            )}
            <CardFooter>
                <EditInfoButton
                    type="button"
                    onClick={goToProfile}
                >Edit Information</EditInfoButton>
                <Button
                    title="Continue"
                    type="button"
                    disabled={!(hasAgreed)}
                    onClick={onSubmit}
                    css={'text-transform: none; padding-bottom: 3px;'}
                    arrowCss={'padding-left: 0px; margin-top: 5px;'}
                />
            </CardFooter>
        </>
    );
};
